import { render, staticRenderFns } from "./commande_client.vue?vue&type=template&id=6d9d1f88&"
import script from "./commande_client.vue?vue&type=script&lang=js&"
export * from "./commande_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports